import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import DeleteFavoriteOptions from '../DeleteFavoriteOptions';

const ModalDeleteFavorite = ({ data = {}, onSuccess = null, onCancel = null }) => {

    const modalProps = {
        childrenClassName: 'modal-delete-tv-channel'
    };

    return (
        <ModalWrapper {...modalProps}>
            <DeleteFavoriteOptions
                data={data}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        </ModalWrapper>
    );
};

export default withOnClose(ModalDeleteFavorite);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDeleteFavorite.jsx